import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, IonCheckbox, IonContent, IonDatetime, IonFab, IonFabButton, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonSegment, IonSegmentButton, IonTextarea, IonTitle, IonToast, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { add, arrowBack, closeOutline, ellipsisVertical, informationCircle, listOutline, notifications, walletOutline, refresh, search, star } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { baixarFinanceiro, requestService, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import FinanceiroAlterar from '../FinanceiroAlterar/FinanceiroAlterar';
import FinanceiroLancamentos from '../FinanceiroLancamentos/FinanceiroLancamentos';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Financeiro.css';

const Financeiro: React.FC = () => {

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const history = useHistory();
  const [arrayFinanceiro, setArrayFinanceiro] = useState<any>([]);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [financeiropk, setFinanceiropk] = useState("");
  const [financeiroFunilk, setFinanceirok] = useState("");
  const [financeirogsi2sk, setFinanceirogsi2sk] = useState("");
  const [showCopiado, setShowCopiado] = useState(false);
  const [listaProjeto, setListaProjeto] = useState<any>([]);
  const [filtroSegment, setFiltroSegment] = useState<string>("");
  const [pesquisaData, setPesquisaData] = useState<any>("Pesquisar");
  // const [pesquisaNome, setPesquisaNome] = useState<any>("Pesquisar");

  const [financeiro, setFinanceiro] = useState<any>();

  const [showLoadingPage, setShowLoadingPage] = useState(false);
  const [showModalData, setShowModalData] = useState(false);
  const popover = useRef<HTMLIonPopoverElement>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [showDetalhesFinanceiro, setShowDetalhesFinanceiro] = useState(false);
  const [showDetalhesFinanceiroAlterar, setShowDetalhesFinanceiroAlterar] = useState(false);
  const { loja, setLoja } = useContext(MessageContext);

  const [exibirInfo, setExibirInfo] = useState(false);

  const [dataVencimento, setDataVencimento] = useState<any>("");
  const [dataCadastro, setDataCadastro] = useState<any>("");
  const [dataBaixa, setDataBaixa] = useState<any>("");
  const [tipo, setTipo] = useState<any>("");
  const [enviarMensagem, setEnviarMensagem] = useState<any>("");
  const [cadastradoPor, setCadastradoPor] = useState<any>("");
  const [baixadoPor, setBaixadoPor] = useState<any>("");
  const [observacoes, setObservacoes] = useState<any>("");
  const [cobranca, setCobranca] = useState<any>("");
  const [opcoes, setOpcoes] = useState<any>("");
  const [parcelas, setVezes] = useState<any>("");
  const [parcela, setParcela] = useState<any>("");

  // const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);

  const { mensagens, setMensagens } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

  const [showModalFiltro, setShowModalFiltro] = useState(false);

  const { filtroCampoSelecionadoFinanceiro, setFiltroCampoSelecionadoFinanceiro } = useContext(MessageContext);
  const { filtroMostrarDataFinanceiro, setFiltroMostrarDataFinanceiro } = useContext(MessageContext);
  const { filtroPesquisaFinanceiro, setFiltroPesquisaFinanceiro } = useContext(MessageContext);
  const { filtroStatusFinanceiro, setFiltroStatusFinanceiro } = useContext(MessageContext);
  const { recarregarFinanceiro, setRecarregarFinanceiro } = useContext(MessageContext);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);

  useEffect(() => {
    // primeira vez q entra e quando troca de loja
    console.log("entrou useEffect mudou loja - Financeiros", loja);
    console.log("entrou useEffect mudou loja - Financeiros", filtroStatusFinanceiro);
    setFiltroCampoSelecionadoFinanceiro("data");
    setFiltroMostrarDataFinanceiro(true);
    setFiltroStatusFinanceiro("Ativo");
    // setRecarregarFinanceiro(false);
    carregarFinanceiroSegmentadaData();
    setPesquisaData('Pesquisar');
  }, [loja]
  );

  useEffect(() => {
    console.log("entrou useEffect mudou loja - filtroCampoSelecionadoFinanceiro, filtroPesquisaFinanceiro, filtroSegment", filtroCampoSelecionadoFinanceiro);
    console.log("entrou useEffect mudou loja - filtroCampoSelecionadoFinanceiro, filtroPesquisaFinanceiro, filtroSegment", filtroPesquisaFinanceiro);
    console.log("entrou useEffect mudou loja - filtroCampoSelecionadoFinanceiro, filtroPesquisaFinanceiro, filtroSegment", filtroSegment);
    if (filtroPesquisaFinanceiro != "" || filtroSegment != "") {
      carregarFinanceiroSegmentadaData();
    }
  }, [filtroPesquisaFinanceiro, filtroSegment]
  );

  useEffect(() => {
    if (recarregarFinanceiro) {
      carregarFinanceiroSegmentadaData();
      setRecarregarFinanceiro(false);
    }
  }, [recarregarFinanceiro]
  );

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("Financeiro");
  })

  // const filtroSelectionChanged = (filtroProjetos: string) => {

  //   if (filtroProjetos != "") {
  //     setFiltroPesquisaFinanceiro(filtroProjetos);
  //     const cliente = listaProjeto.find((prospect: any) => prospect.pk === filtroProjetos);
  //     setPesquisaNome(cliente.nomeProjeto);
  //   }
  //   else {
  //     setFiltroPesquisaFinanceiro("");
  //     setPesquisaNome("Pesquisar");
  //   }
  //   carregarFinanceiroSegmentadaData();
  //   setShowModalFiltro(false);
  // };

  // const consultarProjeto = async () => {

  //   let token: string = "";
  //   const tkn = localStorage.getItem("token");
  //   if (typeof (tkn) === "string") {
  //     token = tkn;
  //   }

  //   let montarUrl = projetoLista.url.replace("{loja}", loja.replaceAll(/#/g, "%23"));

  //   console.log("*******************montarUrl", montarUrl);
  //   setShowLoadingPage(true);
  //   const resp = await fetch(montarUrl,
  //     {
  //       method: "GET",
  //       headers: [
  //         ["token", token]
  //       ],
  //       credentials: 'include'
  //     });
  //   let projetos = await resp.json();
  //   setShowLoadingPage(false);
  //   console.log("projetos", projetos);
  //   if (resp.status === 400 || resp.status === 401) {
  //     history.replace("/login/");
  //   }
  //   else {
  //     if (projetos.Items) {
  //       let lista = projetos.Items.sort((a: any, b: any) => {
  //         const nomeProjetoA = typeof a.nomeProjeto === 'string' ? a.nomeProjeto.toLowerCase() : '';
  //         const nomeProjetoB = typeof b.nomeProjeto === 'string' ? b.nomeProjeto.toLowerCase() : '';

  //         if (nomeProjetoA > nomeProjetoB) return 1;
  //         if (nomeProjetoA < nomeProjetoB) return -1;
  //         return 0;
  //       });
  //       setListaProjeto(lista);
  //     }
  //   }
  // }

  // function trocarCampoFiltro(e: any) {
  //   setFiltroSegment("");
  //   setFiltroCampoSelecionadoFinanceiro(e.detail.value);
  //   if (e.detail.value === 'data') {
  //     console.log('entrou data');
  //     setFiltroMostrarDataFinanceiro(true);


  //   }
  //   else {
  //     console.log('entrou nome');
  //     consultarProjeto();
  //     setFiltroMostrarDataFinanceiro(false);

  //   }
  //   setPesquisaNome("Pesquisar");
  //   setPesquisaData("Pesquisar");
  //   setFiltroPesquisaFinanceiro("");
  //   setArrayFinanceiro([]);
  // }


  const scrollToTop = () => {
    contentRef.current && contentRef.current.scrollToTop();
  };

  function doRefresh(event: any) {
    carregarFinanceiroSegmentadaData();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  function carregarDetalhesProjeto(projetoid: any, empresaid: any, abrirInserirAgendamento: boolean) {
    if (projetoid) {
      history.push("projetos/projetosdetalhes", { projetoid: projetoid, empresaid: empresaid, abrirInserirAgendamento: abrirInserirAgendamento, esconderOperacoes: true })
    }
  }

  function baixaLancamento(pk: any, checked: boolean) {


    let objRequest = {
      "baixado": checked
    };

    console.log("objRequest", objRequest);


    requestService(baixarFinanceiro.url.replace("{id}", pk.replaceAll(/#/g, "%23")), {
      method: baixarFinanceiro.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {

        console.log("response_incluirFinanceiro", response);
        if (response.message) {

          setTextToast("Lançamento baixado com sucesso!");
          setShowToast(true);

        }

      },
      (error: any) => {
        console.log(error);


        setTextToast(error.message);
        setShowToast(true);


      })
  }


  function preencheCard(value: any, indice: any) {
    const editar = () => {
      if (acessos?.financeiro != 'edicao') return;
      setFinanceiro(value);
      setShowDetalhesFinanceiroAlterar(true);
    };
    return (
      <div className={`financeiro-row${value.nomeProjeto ? ' financeiro-row-has-project' : ''}`} key={"financeiro" + indice + value.valor}
        tabIndex={acessos?.financeiro == 'edicao' ? 0 : undefined}
        role={acessos?.financeiro == 'edicao' ? 'button' : undefined}
        aria-label={acessos?.financeiro == 'edicao' ? `Editar lançamento de ${value.categoria}` : undefined}
        onClick={editar}
        onKeyDown={event => {
          if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            editar();
          }
        }}>
        <div className="financeiro-row-category">
          <strong>{value.categoria}</strong>
          <span className={value.tipoLancamento == 'receita' ? 'financeiro-kind receita' : 'financeiro-kind despesa'}>{value.tipoLancamento == 'receita' ? 'Receita' : 'Despesa'}</span>
        </div>
        <div className="financeiro-row-project" data-empty={!value.nomeProjeto} onClick={event => event.stopPropagation()}>
          <button type="button" hidden={!value.projetoid} onClick={(e) => {
              carregarDetalhesProjeto(value.projetoid.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false);
            }}>{value.nomeProjeto}</button>
          {!value.projetoid && <span>{value.nomeProjeto || '—'}</span>}
        </div>
        <div className="financeiro-row-value" data-type={value.tipoLancamento}>
          {value.valor.toLocaleString('pt-br', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
          <IonIcon icon={value.opcoes == "parcelas" ? star + "x" : (value.opcoes == "recorrente" ? refresh : "")} />
        </div>
        <div className="financeiro-row-paid" onClick={event => event.stopPropagation()}>
          <IonCheckbox disabled={acessos?.financeiro != 'edicao'} key={"financeirocheckbox" + indice + value.valor + Math.random()} aria-label={`Baixar lançamento de ${value.categoria}`} checked={value.baixado}

                  onIonChange={e => {
                    console.log(e.detail.checked);
                    baixaLancamento(value.pk.replaceAll(/#/g, '%23'), e.detail.checked);

                    let obj = [...arrayFinanceiro];
                    obj[indice] = { ...obj[indice], baixado: e.detail.checked };

                    setArrayFinanceiro(obj);
                  }}

                ></IonCheckbox>
          <span>{value.baixado ? 'Baixado' : 'Pendente'}</span>
        </div>
        <div className="financeiro-row-actions" onClick={event => event.stopPropagation()}>
          <IonButton aria-label="Informações de cobrança" fill="clear" hidden={value.tipoLancamento == "despesa" || !value.projetoid}
                  onClick={() => {
                    if (value.enviarMensagem) {
                      setTextToast("Cliente vai ser avisado pelo sistema sobre essa cobrança.");
                    }
                    else {
                      setTextToast("Cliente não vai receber essa cobrança.");
                    }
                    setShowToast(true);
                  }}>
                  <IonIcon slot="icon-only" color={value.enviarMensagem == true ? "success" : "danger"} icon={notifications}></IonIcon>
                </IonButton><IonButton aria-label="Detalhes do lançamento" fill="clear"
                  onClick={() => {
                    setObservacoes(value.observacoes);
                    setCobranca(value.cobranca);
                    setDataVencimento(value.data);
                    setCadastradoPor(value.cadastradoPor);
                    setDataCadastro(value.dataCadastro);
                    setDataBaixa(value.dataBaixa);
                    setBaixadoPor(value.baixadoPor);
                    setEnviarMensagem(value.enviarMensagem);
                    setTipo(value.tipoLancamento);
                    setOpcoes(value.opcoes);
                    setVezes(value.parcelas);
                    setParcela(value.parcela);
                    setExibirInfo(!exibirInfo)
                  }}>
                  <IonIcon slot="icon-only" icon={informationCircle} />
                </IonButton>
        </div>
      </div>
    );
  }

  const loadItens = () => {

    if (arrayFinanceiro === undefined || arrayFinanceiro.length === 0) {
      return (
        <div className="financeiro-empty">
          <span className="financeiro-section-icon"><IonIcon icon={walletOutline} aria-hidden="true" /></span>
          <h3>Nenhum lançamento encontrado</h3>
          <p>Os lançamentos do período selecionado aparecerão aqui.</p>
        </div>
      )
    }

    return arrayFinanceiro.map((value: any, index: any, arr: any) =>

      (!arr[index - 1]) ?
        (<div key={"divfinanceiropai" + index}>
          <IonCard className={"card"} key={"financeiro" + index}>
            <IonCardHeader key={"headerfinanceiro" + index}>
              <IonCardTitle key={"titulofinanceiro" + index}>
                <div key={"divfinanceiro" + index} className={"cabecalho"} >{
                  new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(value.data)
                  )
                }</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          {preencheCard(value, index)}
        </div>)
        :
        (value.data.substring(0, 10) !== arr[index - 1].data.substring(0, 10)) ?
          (<div key={"divfinanceiropai" + index}>
            <IonCard className={"card"} key={"financeiro" + index}>
              <IonCardHeader key={"headerfinanceiro" + index}>
                <IonCardTitle key={"titulofinanceiro" + index}>
                  <div key={"divfinanceiro" + index} className={"cabecalho"} >{
                    new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                      Date.parse(value.data)
                    )
                  }</div>
                </IonCardTitle>
              </IonCardHeader>
            </IonCard>
            {preencheCard(value, index)}
          </div>
          ) :
          (
            <div key={"divfinanceiropai" + index}>
              {preencheCard(value, index)}
            </div>
          )
    );
  }

  async function carregarFinanceiroSegmentadaData() {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let data = filtroPesquisaFinanceiro;
      let valor = data;
      if (data) {
        valor = data.replaceAll(/#/g, "%23");
      }

      setShowLoadingPage(true);
      const resp: Response = await fetch(urlBaseCore.url + "/financeiro?campo=" + filtroCampoSelecionadoFinanceiro +
        "&filtro=" + filtroSegment +
        "&valor=" + valor +
        "&lojas=" + Buffer.from(loja).toString('base64'),
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      await resp.json().then(async (res) => {
        if (resp.status === 400 || resp.status === 401) {
          setShowLoadingPage(false);
          history.replace("/login/");
        }

        if (res && res.LastEvaluatedKey) {
          setFinanceiropk(res.LastEvaluatedKey.pk);
          setFinanceirok(res.LastEvaluatedKey.sk);
          setFinanceirogsi2sk(res.LastEvaluatedKey.gsi2sk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setDesabilitarInfiniteScroll(true);
        }

        setArrayFinanceiro(res.Items);
        setShowLoadingPage(false);
      }).finally(() => {
        setShowLoadingPage(false);
      });
    }
    consultar();
  }

  async function carregarMaisFinanceiro($event: CustomEvent<void>) {
    console.log("carregarMaisFinanceiro",);
    if (financeirogsi2sk.includes(filtroSegment)) {
      await carregarMaisFinanceiroChamada().then(() => {
      });
    }
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisFinanceiroChamada() {
    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let valor = filtroPesquisaFinanceiro;
    if (filtroPesquisaFinanceiro) {
      valor = filtroPesquisaFinanceiro.replaceAll(/#/g, "%23");
    }


    console.log(valor);

    const res: Response = await fetch(urlBaseCore.url + "/financeiro?campo=" + filtroCampoSelecionadoFinanceiro +
      "&valor=" + valor +
      "&isk=" + financeirogsi2sk +
      "&pk=" + financeiropk +
      "&sk=" + financeiroFunilk +
      "&lojas=" + Buffer.from(loja).toString('base64'),
      {
        method: urlBaseCore.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    await res
      .json()
      .then(async (financeiroFunil) => {

        if (financeiroFunil.Items) {
          for (let i = 0; i < financeiroFunil.Items.length; i++) {
            arrayFinanceiro.push(financeiroFunil.Items[i]);
          }

          if (financeiroFunil.LastEvaluatedKey) {
            setFinanceiropk(financeiroFunil.LastEvaluatedKey.pk);
            setFinanceirok(financeiroFunil.LastEvaluatedKey.sk);
            setFinanceirogsi2sk(financeiroFunil.LastEvaluatedKey.gsi2sk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setFinanceiropk("");
            setFinanceirok("");
            setFinanceirogsi2sk("");
            setDesabilitarInfiniteScroll(true);
          }
        }

      })
      .catch(err => console.error(err));

    if (res.status === 400 || res.status === 401) history.replace("/login/");

  }


  function avancarFinanceiro() {
    setShowDetalhesFinanceiro(true);
  }

  async function handleSegmentChange(e: any) {
    setFiltroSegment(e.detail.value);
  }

  const openPopoverData = (e: any) => {

    setFiltroSegment("");

    popover.current!.event = e;
    setShowModalData(true);
  };

  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };

  async function closeModalFinanceiro() {
    setShowDetalhesFinanceiro(false);
    carregarFinanceiroSegmentadaData();
  }

  async function closeModalSimpleFinanceiro() {
    setShowDetalhesFinanceiro(false);
  }


  async function closeModalFinanceiroAlterar() {
    setShowDetalhesFinanceiroAlterar(false);
    carregarFinanceiroSegmentadaData();
  }

  async function closeModalSimpleFinanceiroAlterar() {
    setShowDetalhesFinanceiroAlterar(false);
  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  return (
    <IonPage className="financeiro-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="financeiro-toolbar">
          <IonButtons slot="start">

            < IonButton onClick={() => {
              history.goBack();
            }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>

          </IonButtons>

          <IonTitle>Financeiro</IonTitle>


          <IonButtons slot="end">
            <IonButton aria-label="Mais opções" onClick={openPopover}>
              <IonIcon slot="icon-only" icon={ellipsisVertical} />
            </IonButton>
          </IonButtons>


          <IonPopover
            isOpen={showPopover}
            event={popoverEvent}
            onDidDismiss={closePopover}
          >
            <IonList>


              <IonItem lines="none" button
                hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}
                onClick={() => { history.push("/empresa/financeirocategorias"); closePopover(); }}>
                <IonIcon icon={listOutline} slot="start" />
                <IonLabel>Categorias</IonLabel>
              </IonItem>


              <IonItem lines="none" button onClick={closePopover}>
                <IonIcon icon={closeOutline} slot="start" />
                <IonLabel>Cancelar</IonLabel>
              </IonItem>
            </IonList>
          </IonPopover>

        </IonToolbar>


      </IonHeader>


      <IonContent scrollEvents={true} ref={contentRef}>


        {(
          <IonFab className="financeiro-mobile-add" vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.financeiro != 'edicao'}>
            <IonFabButton aria-label="Novo lançamento" color="tertiary" class="custom-fab-button" onClick={() => {
              avancarFinanceiro();
            }} >
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}


        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>


        <div className="financeiro-container">
          <div className="financeiro-heading">
            <div><h1>Financeiro</h1><p>Organize suas receitas, despesas e acompanhe os lançamentos por período.</p></div>
            <IonButton className="financeiro-desktop-add" hidden={acessos?.financeiro != 'edicao'} onClick={avancarFinanceiro}>
              <IonIcon slot="start" icon={add} />Novo lançamento
            </IonButton>
          </div>
          <section className="financeiro-filters" aria-label="Filtrar lançamentos">
            <div className="financeiro-filter-top"><span>Período dos lançamentos</span><IonButton className="financeiro-date-filter" fill="outline" aria-label="Filtrar lançamentos por data" hidden={!filtroMostrarDataFinanceiro} onClick={e => { openPopoverData(e); }} >
            <IonIcon icon={search} hidden={filtroPesquisaFinanceiro != ""}></IonIcon>
            <IonLabel >{pesquisaData} </IonLabel>
          </IonButton>
              <IonButton className="financeiro-refresh" fill="clear" aria-label="Atualizar lançamentos" hidden={isPlatform("android") || isPlatform("ios")} onClick={() => { carregarFinanceiroSegmentadaData(); }}><IonIcon slot="icon-only" icon={refresh} /></IonButton>
            </div><IonSegment
                  value={filtroSegment}
                  onIonChange={(e) => {
                    scrollToTop();
                    handleSegmentChange(e);
                  }}
                  className="financeiro-months" scrollable
                >
                  <IonSegmentButton value="01" >
                    <IonLabel>JAN</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="02" >
                    <IonLabel>FEV</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="03" >
                    <IonLabel>MAR</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="04" >
                    <IonLabel>ABR</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="05" >
                    <IonLabel>MAI</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="06" >
                    <IonLabel>JUN</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="07" >
                    <IonLabel>JUL</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="08" >
                    <IonLabel>AGO</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="09" >
                    <IonLabel>SET</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="10" >
                    <IonLabel>OUT</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="11" >
                    <IonLabel>NOV</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="12" >
                    <IonLabel>DEZ</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
          </section>
          <section className="financeiro-grid" aria-labelledby="financeiro-grid-title">
            <div className="financeiro-section-heading"><span className="financeiro-section-icon"><IonIcon icon={walletOutline} aria-hidden="true" /></span><div><h2 id="financeiro-grid-title">Lançamentos</h2><p>Receitas e despesas do período selecionado</p></div></div>
            <div className="financeiro-grid-columns" aria-hidden="true"><span>Categoria</span><span>Vínculo</span><span>Valor</span><span>Baixa</span><span>Ações</span></div>

          {loadItens()}
          </section>


        </div>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisFinanceiro(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais lançamentos..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonToast
          isOpen={showCopiado}
          onDidDismiss={() => setShowCopiado(false)}
          message="Campo copiado."
          duration={3000}
        />

        <IonModal isOpen={exibirInfo} onDidDismiss={() => setExibirInfo(false)}>
          <IonHeader className="ion-no-border"><IonToolbar><IonTitle>Detalhes do lançamento</IonTitle><IonButtons slot="end"><IonButton fill="clear" aria-label="Fechar" onClick={() => { setExibirInfo(false); }}><IonIcon icon={closeOutline} /></IonButton></IonButtons></IonToolbar></IonHeader>
          <IonContent className="financeiro-form-content financeiro-info-content"><IonList>

                <IonItem className="financeiro-info-item" lines="none">
                  <IonLabel>Data Vencimento: </IonLabel>
                  {dataVencimento ?

                    new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                      Date.parse(dataVencimento)
                    )

                    : ""}


                </IonItem>

                <IonItem className="financeiro-info-item" lines="none">
                  <IonLabel>Cadastrado por: </IonLabel>
                  {cadastradoPor}


                </IonItem>

                <IonItem className="financeiro-info-item" lines="none">
                  <IonLabel>Data Cadastro: </IonLabel>

                  {dataCadastro ?

                    new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                      Date.parse(dataCadastro)
                    )

                    : ""}


                </IonItem>


                <IonItem className="financeiro-info-item" lines="none">
                  <IonLabel>Baixado por: </IonLabel>
                  {baixadoPor}


                </IonItem>


                <IonItem className="financeiro-info-item" lines="none">
                  <IonLabel>Data Baixa: </IonLabel>

                  {dataBaixa ?

                    new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                      Date.parse(dataBaixa)
                    )

                    : ""}
                </IonItem>


                <div className="financeiro-field">
                  <IonLabel className="financeiro-field-label">Observações: </IonLabel>
                  <IonTextarea disabled={true} rows={6} value={observacoes} maxlength={250} placeholder="" onIonInput={(e: any) => setObservacoes(e.target.value)}></IonTextarea>
                </div>


              </IonList></IonContent>
        </IonModal>
        <div className="content">
          <IonModal isOpen={showDetalhesFinanceiro} onDidDismiss={() => { setShowDetalhesFinanceiro(false); }}>
            <FinanceiroLancamentos projetoid={null} tipo={null} observacao={null} closeAction={closeModalFinanceiro} closeActionSimple={closeModalSimpleFinanceiro}></FinanceiroLancamentos>
          </IonModal>


          <IonModal isOpen={showDetalhesFinanceiroAlterar} onDidDismiss={() => { setShowDetalhesFinanceiroAlterar(false); }}>
            <FinanceiroAlterar financeiro={financeiro} closeAction={closeModalFinanceiroAlterar} closeActionSimple={closeModalSimpleFinanceiroAlterar}></FinanceiroAlterar>
          </IonModal>

          <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
            <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
          </IonModal>

        </div>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoadingPage}
          onDidDismiss={() => { setShowLoadingPage(false); }}
          spinner='circles'
        />

      </IonContent>

      <IonPopover ref={popover}
        isOpen={showModalData}
        onDidDismiss={() => setShowModalData(false)} >
        <IonDatetime
          presentation='date'
          onIonChange={e => {
            if (e.detail.value) {
              let data = e.detail.value.toString().substring(0, 10);
              const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                Date.parse(data)
              );
              setPesquisaData(dataFormatada);
              setFiltroPesquisaFinanceiro(data);
            }
          }}></IonDatetime>

      </IonPopover >
    </IonPage>
  );
};

export default Financeiro;
